
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22.891","height":"19.065"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#1472e6","stroke-linejoin":"round"}},[_c('g',{attrs:{"transform":"rotate(180 10.5 3.5)","fill":"#1472e6"}},[_c('rect',{attrs:{"width":"21","height":"7","rx":"2","stroke":"none"}}),_c('rect',{attrs:{"x":".5","y":".5","width":"20","height":"6","rx":"1.5","fill":"none"}})]),_c('path',{attrs:{"d":"M9.935 4.13L13.32 15.79a.142.142 0 00.27.008l1.128-3.153 4.536 5.304 2.947-2.52-4.51-5.274 3.298-.561a.142.142 0 00.038-.267l-10.89-5.362a.142.142 0 00-.202.167z","fill":"#e7f1fd","stroke-linecap":"round","stroke-width":"1.00045"}})])])
          )
        }
      }
    